var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasExtencion('enviar_mail_a_clientes'))?_c('b-dropdown-item',{on:{"click":function($event){$event.preventDefault();return _vm.on_click.apply(null, arguments)}}},[_c('i',{staticClass:"icon-message"}),_vm._v(" Enviar correo a clientes (selección) ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }